var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_530_1072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49328 1.01396C8.82614 0.964495 9.16512 1.04761 9.43735 1.24543C9.70958 1.44325 9.89332 1.73998 9.94908 2.07184C10.0048 2.4037 9.92816 2.7442 9.73553 3.02012C9.5429 3.29605 9.2497 3.48538 8.91895 3.54741C7.42267 3.80116 6.06455 4.5765 5.08535 5.73599C4.10614 6.89549 3.5691 8.36423 3.56942 9.88189C3.56942 11.5855 4.24618 13.2194 5.45083 14.424C6.65548 15.6287 8.28934 16.3054 9.99297 16.3054V18.8749C5.02628 18.8749 1 14.8494 1 9.88189C1 5.47533 4.19122 1.73682 8.49328 1.01396Z",
    fill: "url(#paint0_linear_530_1072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1825 3.28487C14.2952 3.15918 14.4315 3.05693 14.5837 2.98395C14.7359 2.91097 14.901 2.8687 15.0696 2.85955C15.2381 2.85041 15.4068 2.87456 15.566 2.93064C15.7252 2.98672 15.8718 3.07362 15.9974 3.18638C16.9386 4.02917 17.6913 5.06118 18.2063 6.21489C18.7212 7.3686 18.9868 8.61802 18.9856 9.88143C18.9856 14.849 14.9594 18.8744 9.99268 18.8744V16.305C11.2929 16.305 12.5626 15.9104 13.6338 15.1734C14.705 14.4364 15.5273 13.3916 15.992 12.1772C16.4568 10.9629 16.542 9.63604 16.2365 8.37217C15.931 7.10831 15.2491 5.96692 14.281 5.09888C14.0275 4.87137 13.8746 4.55246 13.8561 4.21227C13.8377 3.87209 13.9551 3.5385 14.1825 3.28487Z",
    fill: "url(#paint1_linear_530_1072)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_530_1072",
    x1: -2.42589,
    y1: -1.25222,
    x2: 9.1365,
    y2: 17.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#858585"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_530_1072",
    x1: 15.988,
    y1: -0.396138,
    x2: 0.143234,
    y2: 15.0204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_530_1072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.531304f4b468cfbc4c8467346bb25ec9.svg";
export { ForwardRef as ReactComponent };